'use client';

import Icon from '@/components/ui/AppIcon';


export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Full-width Background Image */}
      <div className="absolute inset-0 z-0">
        <div className="relative w-full h-full bg-gradient-to-br from-green-900 to-green-700">
          <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1548550023-2bdb3c5beed7?w=1920&q=80')] bg-cover bg-center opacity-40" />
          <div className="absolute inset-0 bg-gradient-to-r from-green-900/90 via-green-800/80 to-transparent" />
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center pt-32 pb-20 px-6">
        {/* Left Content */}
        <div className="space-y-8 reveal">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 glass-card rounded-full px-5 py-2.5">
            <div className="w-2 h-2 rounded-full bg-white animate-pulse" />
            <span className="text-sm font-semibold text-white">Premium Dutch Quality</span>
          </div>

          {/* Headline */}
          <h1 className="text-heading-1 md:text-[4rem] lg:text-[4.5rem] leading-[1.1] text-white">
            Premium Poultry Nutrition for Maximum Farm Performance
          </h1>

          {/* Description */}
          <p className="text-lg md:text-xl text-white/90 leading-relaxed max-w-xl">
            High-quality Dutch-formulated feed concentrates designed to increase egg production, accelerate broiler growth, and maximize farmer profitability in Uganda.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="/products"
              className="group inline-flex items-center justify-center gap-3 bg-[#66BB6A] text-white px-10 py-5 rounded-full text-lg font-bold hover:bg-[#2E7D32] hover:scale-105 transition-all duration-300 shadow-2xl hover:shadow-[0_20px_50px_rgba(46,125,50,0.4)]">
              
              <span>View Products</span>
              <Icon name="ArrowRightIcon" size={24} className="group-hover:translate-x-2 transition-transform duration-300" />
            </a>
            <a
              href="#contact"
              className="group inline-flex items-center justify-center gap-3 bg-white text-[#2E7D32] px-10 py-5 rounded-full text-lg font-bold hover:bg-[#66BB6A] hover:text-white hover:scale-105 transition-all duration-300 shadow-xl hover:shadow-2xl border-2 border-white">
              
              <Icon name="UserGroupIcon" size={24} className="group-hover:rotate-12 transition-transform duration-300" />
              <span>Become a Distributor</span>
            </a>
          </div>

          {/* Stats Row */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 pt-8">
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-white mb-1">40+</div>
              <div className="text-sm text-white/80">Years European Expertise</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-white mb-1">250+</div>
              <div className="text-sm text-white/80">Local Families Served</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-white mb-1">10-15%</div>
              <div className="text-sm text-white/80">Increase in Production</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-white mb-1">100%</div>
              <div className="text-sm text-white/80">Dutch Quality Standards</div>
            </div>
          </div>
        </div>

        {/* Right Image */}
        <div className="relative reveal" style={{ animationDelay: '0.2s' }}>
          <div className="relative rounded-3xl overflow-hidden shadow-2xl">
            <div className="aspect-[4/3] bg-gradient-to-br from-green-100 to-green-50">
              <img
                src="https://img.rocket.new/generatedImages/rocket_gen_img_1c8c0bf81-1764687936488.png"
                alt="Healthy layer hens in modern poultry farm with clean environment and organized feeding system"
                className="w-full h-full object-cover" />
              
            </div>
          </div>
          {/* Floating badge */}
          <div className="absolute -bottom-6 -left-6 glass-card rounded-2xl p-6 shadow-xl">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center">
                <Icon name="CheckBadgeIcon" size={28} className="text-primary" />
              </div>
              <div>
                <div className="text-2xl font-bold text-foreground">100%</div>
                <div className="text-sm text-muted-foreground">Quality Assured</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

}